import { buildFilterMapping } from '@/components/AgGrid/helpers/filterHelpers';
import { doesDateFilterPass } from '@/components/AgGrid/components/AgDateFilter/doesDateFilterPass';

const filterMappingByColumnType = [
  {
    string: { filter: 'agTextColumnFilter' },
  },
  {
    number: { filter: 'agNumberColumnFilter' },
  },
  {
    integer: { filter: 'agNumberColumnFilter' },
  },
  {
    // client-side grid: with filter handlers on, the grid filters rows through the column, not the popup
    date: { filter: { component: 'customDateFilter', doesFilterPass: doesDateFilterPass } },
  },
  {
    boolean: { filter: 'agSetColumnFilter' },
  },
  {
    select: { filter: 'agSetColumnFilter' },
  },
];

export const filterMapping = buildFilterMapping(filterMappingByColumnType);
